import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiClient from '../utils/api';
import { useAuthStore } from '../store/authStore';
import { setToken } from '../utils/tokenStorage';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setUser = useAuthStore((state) => state.setUser);
  const [error, setError] = useState(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const savedState = sessionStorage.getItem('google_oauth_state');
      sessionStorage.removeItem('google_oauth_state');

      if (!code) {
        setError('Google sign-in was cancelled or failed.');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }
      if (savedState && state !== savedState) {
        setError('Security check failed. Please try signing in again.');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      try {
        const response = await apiClient.post('/auth/google', {
          code,
          redirect_uri: window.location.origin + '/auth/google'
        });
        const userData = response.data;
        setToken(userData.session_token);
        setUser(userData);
        sessionStorage.setItem('just_authenticated', 'true');
        navigate('/dashboard', { replace: true, state: { user: userData } });
      } catch (err) {
        setError(err.response?.data?.detail || 'Google sign-in failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    run();
  }, [searchParams, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="glass-default rounded-2xl p-8 max-w-md">
          <div className="text-center">
            <p className="text-lg text-red-400 mb-2" data-testid="google-auth-error">{error}</p>
            <p className="text-sm text-white/50">Redirecting to login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass-default rounded-2xl p-8">
        <div className="animate-pulse text-center">
          <div className="w-16 h-16 border-4 border-violet-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-lg text-white/70">Signing you in with Google...</p>
        </div>
      </div>
    </div>
  );
}
